(function () {
    'use strict';
    var archive = document.querySelector('.bh-activity-archive');
    if (!archive) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var entries = Array.from(archive.querySelectorAll('.bh-activity-event'));
    if ('IntersectionObserver' in window && !reduced.matches) {
        var reveal = new IntersectionObserver(function (changes) {
            changes.forEach(function (change) {
                if (change.isIntersecting) {
                    change.target.classList.remove('is-waiting');
                    reveal.unobserve(change.target);
                }
            });
        }, {rootMargin: '0px 0px 35px 0px', threshold: 0});
        entries.forEach(function (entry) {
            if (entry.getBoundingClientRect().top > window.innerHeight) {
                entry.classList.add('is-waiting');
                reveal.observe(entry);
            }
        });
        reduced.addEventListener('change', function () {
            if (reduced.matches) {
                reveal.disconnect();
                entries.forEach(function (entry) { entry.classList.remove('is-waiting'); });
            }
        });
    }
    var years = Array.from(archive.querySelectorAll('[data-archive-year]'));
    var yearLinks = Array.from(archive.querySelectorAll('.bh-activity-index a'));
    var scheduled = false;
    function updateProgress() {
        var current = years[0];
        years.forEach(function (year) {
            var rect = year.getBoundingClientRect();
            if (rect.top <= 180) current = year;
            var track = year.querySelector('.bh-activity-events');
            var trackRect = track.getBoundingClientRect();
            track.style.setProperty('--archive-progress', Math.max(0, Math.min(1, (window.innerHeight * 0.55 - trackRect.top) / trackRect.height)));
        });
        yearLinks.forEach(function (link) {
            if (link.hash === '#' + current.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
        });
        scheduled = false;
    }
    function queueProgress() {
        if (!scheduled) { scheduled = true; window.requestAnimationFrame(updateProgress); }
    }
    window.addEventListener('scroll', queueProgress, {passive: true});
    window.addEventListener('resize', queueProgress);
    window.addEventListener('load', queueProgress);
    updateProgress();

    var dialog = archive.querySelector('.bh-archive-viewer');
    if (!dialog || !dialog.showModal) return;
    var image = dialog.querySelector('img');
    var caption = dialog.querySelector('[data-archive-caption]');
    var title = dialog.querySelector('#archive-viewer-title');
    var counter = dialog.querySelector('[data-archive-count]');
    var previous = dialog.querySelector('[data-archive-prev]');
    var next = dialog.querySelector('[data-archive-next]');
    var original = dialog.querySelector('[data-archive-original]');
    var collection = [], index = 0, opener = null;
    function render() {
        var link = collection[index], source = link.querySelector('img');
        image.src = link.href;
        image.alt = source.alt;
        caption.textContent = source.alt;
        original.href = link.href;
        counter.textContent = (index + 1) + ' / ' + collection.length;
        previous.disabled = index === 0;
        next.disabled = index === collection.length - 1;
    }
    archive.querySelectorAll('[data-archive-photo]').forEach(function (link) {
        link.addEventListener('click', function (event) {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            opener = link;
            var group = link.closest('[data-archive-group]');
            collection = Array.from(group.querySelectorAll('[data-archive-photo]'));
            index = collection.indexOf(link);
            title.textContent = group.getAttribute('data-archive-title');
            render();
            dialog.showModal();
            document.body.classList.add('bh-archive-viewer-open');
        });
    });
    function step(direction) {
        var target = index + direction;
        if (target < 0 || target >= collection.length) return;
        index = target;
        render();
    }
    previous.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    dialog.querySelector('[data-archive-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); step(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); step(1); }
    });
    dialog.addEventListener('close', function () {
        document.body.classList.remove('bh-archive-viewer-open');
        if (opener) opener.focus({preventScroll: true});
    });
}());
